export default function QuizQuestionOption({ optionElementId, optionIndex, optionText, buttonStyle, optionClickedCallback }) {
    return (
        <div className="content-item-flex">
            <button id={optionElementId} className={buttonStyle} onClick={() => optionClickedCallback(optionIndex)}>
                {optionText}
            </button>
        </div>
    );
}